if (!customElements.get("bm-gopuff")) customElements.define("bm-gopuff", class BMGopuff extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            carouselEl: ".js-carousel"
        };
        this.carouselEl = this.querySelector(this.selectors.carouselEl);
        this.init();
    }
    init() {
        this.carousel = new window.Flickity(this.carouselEl, {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: true,
            accessibility: false,
            groupCells: true,
            arrowShape: "M10 3L2 13L10 23"
        });
        document.addEventListener("DOMContentLoaded", ()=>{
            this.carousel.resize();
        });
    }
});